module.exports = __webpack_public_path__ + "static/media/metro.56ad7a1e.jpg";